const Footer = () => {
  return (
    <p className="footer">
      Copyright &copy; {new Date().getFullYear()} Z-Score
    </p>
  );
};

export default Footer;
